// Reine Praesentations-Bauteile fuer die Settings-Seite, ausgelagert aus
// routes/Settings.tsx (Redesign: Gruppierung der 15 Abschnitte in Tabs) nur
// um die Hauptdatei unter der 500-Zeilen-Grenze zu halten. Wortgleiche
// Verschiebung — keine Logik-/Prop-Aenderung.

export interface ToggleProps {
  icon?: preact.JSX.Element;
  label: string;
  description?: string;
  checked: boolean;
  onChange: (next: boolean) => void;
  disabled?: boolean;
  badge?: string;
}

export function Toggle(props: ToggleProps): preact.JSX.Element {
  return (
    <label class="flex items-start gap-3 px-4 py-3 cursor-pointer hover:bg-[color:var(--color-surface-container-low)] transition-colors">
      {props.icon && (
        <span class="mt-0.5 text-[color:var(--color-on-surface-variant)]">{props.icon}</span>
      )}
      <span class="flex-1 min-w-0">
        <span class="flex items-center gap-2">
          <span class="text-sm font-medium text-[color:var(--color-on-surface)]">
            {props.label}
          </span>
          {props.badge && (
            <span class="rounded-full bg-[color:var(--color-tertiary-container)] px-2 py-0.5 text-label uppercase tracking-wider text-[color:var(--color-on-tertiary-container)]">
              {props.badge}
            </span>
          )}
        </span>
        {props.description && (
          <span class="block text-xs text-[color:var(--color-on-surface-variant)] mt-0.5">
            {props.description}
          </span>
        )}
      </span>
      <input
        type="checkbox"
        checked={props.checked}
        onChange={(e) => props.onChange((e.target as HTMLInputElement).checked)}
        disabled={props.disabled}
        class="mt-1 size-4 accent-[color:var(--color-primary)]"
      />
    </label>
  );
}

export interface ThemeCardProps {
  active: boolean;
  onClick: () => void;
  icon: preact.JSX.Element;
  label: string;
  description: string;
}

export interface DensityButtonProps {
  active: boolean;
  onClick: () => void;
  label: string;
}

export function DensityButton(props: DensityButtonProps): preact.JSX.Element {
  return (
    <button
      type="button"
      onClick={props.onClick}
      aria-pressed={props.active}
      class={`px-3 py-1.5 text-xs font-medium border-r border-[color:var(--color-outline-variant)] last:border-r-0 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-[color:var(--color-primary)] focus-visible:ring-offset-2 ${
        props.active
          ? "bg-[color:var(--color-primary)] text-[color:var(--color-on-primary)]"
          : "bg-[color:var(--color-surface-container-lowest)] text-[color:var(--color-on-surface-variant)] hover:bg-[color:var(--color-surface-container-low)]"
      }`}
    >
      {props.label}
    </button>
  );
}

export function ThemeCard(props: ThemeCardProps): preact.JSX.Element {
  return (
    <button
      type="button"
      onClick={props.onClick}
      class={`flex flex-col items-start gap-1.5 rounded-lg border-2 px-3 py-3 text-left transition-all focus:outline-none focus-visible:ring-2 focus-visible:ring-[color:var(--color-primary)] focus-visible:ring-offset-2 ${
        props.active
          ? "border-[color:var(--color-primary)] bg-[color:var(--color-primary-container)]/30"
          : "border-[color:var(--color-outline-variant)] bg-[color:var(--color-surface-container-lowest)] hover:border-[color:var(--color-primary)]/50 hover:bg-[color:var(--color-surface-container-low)]"
      }`}
      aria-pressed={props.active}
    >
      <span
        class={
          props.active
            ? "text-[color:var(--color-primary)]"
            : "text-[color:var(--color-on-surface-variant)]"
        }
      >
        {props.icon}
      </span>
      <span class="text-sm font-medium text-[color:var(--color-on-surface)]">
        {props.label}
      </span>
      <span class="text-label text-[color:var(--color-on-surface-variant)] leading-tight">
        {props.description}
      </span>
    </button>
  );
}
